// extracted by mini-css-extract-plugin
module.exports = {"root":"Footer_root__1zNhd","right":"Footer_right__1Ay6j","buttons":"Footer_buttons__DRcmZ"};